var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theader"},_vm._l((_vm.labels),function(ref,i){
var label = ref.label;
var nonClickable = ref.nonClickable;
var sellTitle = ref.sellTitle;
var field = ref.field;
return _c('div',{key:i,staticClass:"th",class:[{sorted: field === _vm.sortedBy.field}, sellTitle],on:{"click":function($event){return _vm.sortingByLabel(field, nonClickable)}}},[_c('lei-popover',{attrs:{"text":_vm.getTip(label)}},[_c('label',{staticClass:"th-label default-bold w-6"},[_vm._v(_vm._s(label))]),(!nonClickable)?_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":_vm.sortedBy.desc && field === _vm.sortedBy.field ? 'caret-up': 'caret-down'}}):_vm._e()],1)],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a627317a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/data-table/THeader.vue
// module id = null
// module chunks = 